
import { FC, useContext, useMemo } from 'react';

import useGetUserGroupsConfig from '../../../hooks/data/useGetUserGroupsConfig';
import { UserGroupsContext } from '../../../contexts/data/UserGroupsContext';
import { IHasChildren } from '../../common/types/IHasChildren';
import AuthContext from '../../../contexts/auth/AuthContext';


interface IUserGroupsProviderProps extends IHasChildren { }

const UserGroupsProvider: FC<IUserGroupsProviderProps> = ({
    children
}) => {

    const { user, validating } = useContext(AuthContext);

    const userGroups = useGetUserGroupsConfig(user && !validating ? { id: user.id } : undefined, { errorRetryCount: 0 });

    const context = useMemo(() => {
        return userGroups;
    }, [userGroups.data]);

    return (
        <UserGroupsContext.Provider value={context}>
            {children}
        </UserGroupsContext.Provider>
    )
}

export default UserGroupsProvider;